import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"float":"left"} }
const _hoisted_2 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!

  return (_openBlock(), _createBlock(_component_catalog_picker_component, {
    ref: "c",
    auth: "",
    size: _ctx.size,
    modelValue: _ctx.selectedCustomer,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCustomer) = $event)),
      _ctx.emitUpdate
    ],
    placeholder: _ctx.searchPlaceholder ?? 'Поиск контрагентов по инициалам, названию компании, телефону или email',
    "catalog-tab": _ctx.counterpartiesCatalogTab,
    "search-url": "/api/counterparties/search",
    "search-parameters": { types: _ctx.counterpartyType },
    onCatalogItemPicked: _ctx.onCustomerPickedFromCatalog
  }, {
    empty: _withCtx(() => [
      _createTextVNode(" Подрядчиков по запросу не найдено ☹️ ")
    ]),
    default: _withCtx((scope) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(`${scope.lastname} ${scope.firstname} ${scope.middlename ?? ''}`), 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(scope.phone), 1)
    ]),
    label: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, _toDisplayString(`${_ctx.selectedCustomer!.lastname} ${_ctx.selectedCustomer!.firstname} ${_ctx.selectedCustomer!.middlename ?? ''}`), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedCustomer!.phone), 1)
    ]),
    _: 1
  }, 8, ["size", "modelValue", "placeholder", "catalog-tab", "onUpdate:modelValue", "search-parameters", "onCatalogItemPicked"]))
}